
import React, { useState } from 'react';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import DrawerBody from "./drawer"
import SaveReport from "./saveReports"

const styles = () => ({
  menuicon: {
    color: '#333',
    "&:hover": {
      color: "#26bbed"
    }
  },
  menuroot: {
    boxShadow: '0px 4px 10px rgba(204, 204, 204, 0.5)',
    background: "white",
    padding: 0,
    width: "229px"
  },
  listbtn: {
    height: 48,
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#eee',
    },

    '&:hover p': {
      color: '#26BBED',
    },
    '&:hover div span i': {
      color: '#26BBED',
    },
  },
  menutext: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.44px',
    color: '#333333',
    padding: "10px 14px",
    cursor: "pointer",
    '&:hover': {
      color: '#26BBED',
    },
  },
  list: {
    padding: 0
  },
  border: {
    borderTop: "1px solid #dadada"
  }
})

// const menu = ['Email Report', 'Schedule Email', 'Export Report', 'Duplicate Report']
const menu = ['Export Report']


const MenuList = React.memo(({ classes, reportData, showNotification, subOrgDetails }) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const handleToggle = () => {
    setOpen(!open)
  }

  const handleOpenDrawer = (item) => {
    setOpenDrawer(item)
  }

  const toggleDrawer = () => {
    setOpenDrawer(false)
  }

  const openMenu = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setMenuAnchorEl(null);
  };

  const handleClick = (item) => {
    setMenuAnchorEl(null);
    if (item == "Duplicate Report") {
      setOpen(true)
    } else {
      handleOpenDrawer(item)
    }
  }

  const renderMenuItem = (item, index) => {
    return (
      <Typography onClick={() => handleClick(item)}
        key={index} className={`${classes.menutext} ${index == menu.length - 1 ? classes.border : ""}`} variant='body1'>
        {item}
      </Typography>)
  }

  // console.log("reportData", reportData)


  return (
    <>
      <IconButton
        aria-label='more'
        aria-haspopup='true'
        aria-controls='simple-menu'
        onClick={openMenu}
      >
        <MoreVertIcon className={classes.menuicon} />
      </IconButton>
      <Menu
        id='simple-menu'
        anchorEl={menuAnchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        open={Boolean(menuAnchorEl)}
        onClose={closeMenu}
        classes={{
          paper: classes.menuroot,
          list: classes.list
        }}
      >
        {
          menu.map(renderMenuItem)
        }
      </Menu>
      <SaveReport
        open={open}
        handleToggle={handleToggle}
        reportData={reportData}
        showNotification={showNotification}
        subOrgDetails={subOrgDetails}
        duplicate={true}
      />
      <Drawer
        anchor={'right'}
        open={openDrawer}
        onClose={toggleDrawer}
      >
        <DrawerBody title={openDrawer} showNotification={showNotification} onClose={toggleDrawer} id={reportData.id} />
      </Drawer>
    </>
  );
})



export default withStyles(styles)(MenuList)


